import 'minireset.css'
import './styles.css'

export { wrapRootElement as wrapPageElement } from './wrapRootElement'
